module.exports = __webpack_public_path__ + "static/img/shampoo_top_image01.b7f4b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shampoo_top_image01.jpg
// module id = n7Kh
// module chunks = 1